<div class="filters" [formGroup]="formFilters" *ngIf="!loading">
  <div class="item">
    <mtg-dropdown
      formControlName="tournament_season_id"
      [errorVisible]="false"
      label="Сезон"
      size="sm"
    >
      <mtg-dropdown-item [value]="null">Все</mtg-dropdown-item>
      <mtg-dropdown-item
        *ngFor="let item of seasons"
        [value]="item.id"
      >{{ item.name }}</mtg-dropdown-item>
    </mtg-dropdown>
  </div>

  <div class="item" *ngIf="tournaments.length > 0">
    <mtg-dropdown
      formControlName="tournament_id"
      [errorVisible]="false"
      label="Турнир"
      size="sm"
    >
      <mtg-dropdown-item [value]="null">Все</mtg-dropdown-item>
      <mtg-dropdown-item
        *ngFor="let item of tournaments"
        [value]="item.id"
      >{{ item.name }}</mtg-dropdown-item>
    </mtg-dropdown>
  </div>

  <div class="item" *ngIf="rounds.length > 1">
    <mtg-dropdown
      formControlName="tournament_round_id"
      size="sm"
      label="Раунд"
      [errorVisible]="false"
    >
      <mtg-dropdown-item [value]="null">Все</mtg-dropdown-item>
      <mtg-dropdown-item
        *ngFor="let item of rounds"
        [value]="item.id"
      >{{ item.name }}</mtg-dropdown-item>
    </mtg-dropdown>
  </div>

  <div class="item" *ngIf="divisions.length > 0">
    <mtg-dropdown
      formControlName="division_id"
      [errorVisible]="false"
      label="Дивизион"
      size="sm"
    >
      <mtg-dropdown-item [value]="null">Все</mtg-dropdown-item>
      <mtg-dropdown-item
        *ngFor="let item of divisions"
        [value]="item.id"
      >{{ item.name }}</mtg-dropdown-item>
    </mtg-dropdown>
  </div>

  <div class="item" *ngIf="groups.length > 1">
    <mtg-dropdown
      formControlName="tournament_group_id"
      [errorVisible]="false"
      label="Группа"
      size="sm"
    >
      <mtg-dropdown-item [value]="null">Все</mtg-dropdown-item>
      <mtg-dropdown-item
        *ngFor="let item of groups"
        [value]="item.id"
      >{{ item.name }}</mtg-dropdown-item>
    </mtg-dropdown>
  </div>
  <div class="item" *ngIf="tours.length > 0">
    <mtg-dropdown
      formControlName="tournament_tour"
      [errorVisible]="false"
      [label]="league.sport.isRugby() ? 'Неделя' : 'Тур'"
      size="sm"
    >
      <mtg-dropdown-item [value]="null">Все</mtg-dropdown-item>
      <mtg-dropdown-item
        *ngFor="let tour of tours"
        [value]="tour"
      >{{ tour }} {{ league.sport.isRugby() ? 'Неделя' : 'Тур' }}</mtg-dropdown-item>
    </mtg-dropdown>
  </div>
  <div class="item" *ngIf="playoffRounds.length > 0">
    <mtg-dropdown
      formControlName="playoff_round"
      [errorVisible]="false"
      label="Раунд плей-офф"
      size="sm"
    >
      <mtg-dropdown-item [value]="null">Все</mtg-dropdown-item>
      <mtg-dropdown-item
        *ngFor="let item of playoffRounds"
        [value]="item"
      >
        <ng-container *ngIf="item !== 1">1/{{ item }}</ng-container>
        <ng-container *ngIf="item === 1">Финал</ng-container>
      </mtg-dropdown-item>
    </mtg-dropdown>
  </div>

  <div class="item" *ngIf="perGameFilterVisible">
    <mtg-dropdown
      formControlName="per_game"
      [errorVisible]="false"
      size="sm"
    >
      <mtg-dropdown-item [value]="false">Суммарно</mtg-dropdown-item>
      <mtg-dropdown-item [value]="true">Среднее</mtg-dropdown-item>
    </mtg-dropdown>
  </div>

  <div class="search" *ngIf="additionalFiltersVisible">
    <mtg-text-field
      size="sm"
      [errorVisible]="false"
      placeholder="Поиск"
      leadingIcon="icons-search"
      [formControl]="searchControl"
    ></mtg-text-field>
  </div>
</div>
<div class="loading" *ngIf="loading">
  <mtg-spinner></mtg-spinner>
</div>
